import { BaseApiClient } from '../base-api-client';
export class TokenAnalysisClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/token-analysis`,
        };
        super(fullConfig, 'TokenAnalysisClient');
    }
    async getTokenAnalysis(tokenName, params) {
        try {
            const response = await this.post(`/${encodeURIComponent(tokenName)}`, params);
            return response ?? null;
        }
        catch (error) {
            console.error('[TokenAnalysisClient] Error getting token analysis:', this.truncateError(error));
            return null;
        }
    }
    async queueTokenAnalysis(payload) {
        try {
            const response = await this.post('/queue', payload);
            return response ?? { queued: false };
        }
        catch (error) {
            console.error('[TokenAnalysisClient] Error queuing token analysis:', this.truncateError(error));
            throw error;
        }
    }
    async getCompletedAnalyses() {
        try {
            const response = await this.get('/');
            if (!response.success) {
                throw new Error(response.error || 'Failed to get completed analyses');
            }
            return response.data || [];
        }
        catch (error) {
            console.error('[TokenAnalysisClient] Error getting completed analyses:', this.truncateError(error));
            throw error;
        }
    }
}
//# sourceMappingURL=token-analysis-client.js.map